<template>
<v-layout row justify-center align-center>
  <v-flex xs12 sm6 md5 lg4 xl3>
    <v-layout row>
      <v-flex>
        <sp-login-form></sp-login-form>
      </v-flex>
    </v-layout>
  </v-flex>
</v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import SpLoginForm from '../components/SpLoginForm'
import store from '../store/index'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components:{
      SpLoginForm
    },
    data(){
        return{
            loadingUF:false,
            city:null,
            state:null,
            managername:'',
            password:'',
            email:'',
            restaurantname:'',
            loading:false,
            error:null,
            tag:null
        }
    },
    async beforeRouteEnter(to,from,next){
      if(store.state.token)
        next({name:'AllProducts'})
      else
        next()
    },
    computed:{
        ...mapGetters([
            'cities',
            'states',
            'tags'
        ])
    },
    methods:{
      clear(){
        this.city = null
        this.state = null
        this.managername = ''
        this.password = ''
        this.email = ''
        this.restaurantname = ''
        this.$validator.reset()
      },
      async onSubmit(event){
        try {
            this.loading = true
            let valid = await this.$validator.validateAll()
            if(valid){
                let {city,state,managername,password,email,restaurantname,tag} = this
                let res = await this.$store.dispatch('createRestaurant',{
                    city,state,managername,password,email,restaurantname,tag
                })
                if(!res.ok){
                    this.error = res.error
                }else{
                    this.error = null
                }
                this.loading = false
            }
        } catch (error) {
            this.error = "Algo inesperado aconteceu."
        } finally {
          this.loading = false
        }
      },
      async loadCities(){
        if(!this.state)return

        this.loadingUF = true
        await this.$store.dispatch('getCities',this.state)
        this.loadingUF = false
      }
    }

}
</script>

<style>

</style>